import styled from 'styled-components';

export const Line = styled.hr`
    color: ${({ theme }) => theme.colors.white};
    margin: 32px 0;
`;
